import ChildlessPlaceholderUi from './ui/ChildlessPlaceholderUi'

export default ChildlessPlaceholderUi
